import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { project } from "../project";
import { debuggerMode } from "../setting";
import { addScript } from "../utils/utils";
var peckerUrl = '//vm.gtimg.cn/tencentvideo/script/modules/pecker.js?max_age=86400';
export var pecker;
export function setup() {
  return _setup.apply(this, arguments);
}

function _setup() {
  _setup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref,
        _ref$use,
        use,
        _ref$projectName,
        projectName,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$use = _ref.use, use = _ref$use === void 0 ? true : _ref$use, _ref$projectName = _ref.projectName, projectName = _ref$projectName === void 0 ? '' : _ref$projectName;

            if (!use) {
              _context.next = 11;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return addScript(peckerUrl);

          case 5:
            // @ts-ignore
            pecker = window.pecker = window.Pecker(projectName || project.name || 'vip-act', {
              // 调试模式下console日志全量上报，否则只有console.debug会上报
              logReporter: function logReporter() {
                return {
                  sample: debuggerMode ? 1 : 0 // 抽样率必须是0~1

                };
              }
            });
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            console.error('加载啄木鸟接口sdk失败', _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));
  return _setup.apply(this, arguments);
}